'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const provideContext = require('fluxible-addons-react/provideContext');
const CurrencySelect = provideContext(require('./CurrencySelect'));

const currencySelectHelper = {
    init(payload = {}) {
        const { context, select } = payload;
        const dataTn = select && select.dataset.tn;

        // make sure currency selector exist in the page
        if (select) {
            ReactDOM.render(
                React.createElement(CurrencySelect, {
                    context: context.getComponentContext(),
                    dataTn: dataTn,
                }),
                select
            );
        }
    },
};

module.exports = currencySelectHelper;



// WEBPACK FOOTER //
// ./assets/js/components/CurrencySelect/currencySelect-helper.es.js